import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import db from './db';
import BeaconHistoryPopup from './BeaconHistoryPopup';
import CricutLabelPopup from './CricutLabelPopup';
var functions = require("./functions.js");
var tableColumnRender = require("./TableColumnRender.js")
// BeaconTable component
export default class BeaconTable extends React.Component {

    messagesEnd=undefined;

    // constructor
    constructor(props) {
        super(props);

        // initalize state
        this.state = {
            beacons:[],
            beaconPair:undefined,
            initMajor:this.props.initMajor
        }
        this.inputRef = React.createRef();
    }
    componentDidMount() {
        this.inputRef.current.focus();
        if(this.state.initMajor){
            setTimeout(function() { //Start the timer
                this.queryBeacons();  // wait to query hub
            }.bind(this), 2000)            
        }

    }
    inputFilterKeyUp(event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          this.queryBeacons();
        }
    }
    // render
    render() {

        return (
            <div>
                <div>
                    major:<input id="major" type="number" defaultValue={this.state.initMajor} className='input-filter' onKeyUp={this.inputFilterKeyUp.bind(this)} ref={this.inputRef}/>&nbsp;
                    minor:<input id="minor" type="number" className='input-filter' onKeyUp={this.inputFilterKeyUp.bind(this)} />&nbsp;
                    barcode:<input id="barcode" type="number" className='input-number' />&nbsp;
                    hostname:<input id="hostnames" className='input-filter' onKeyUp={this.inputFilterKeyUp.bind(this)} />&nbsp;
                    <button onClick={()=>{this.queryBeacons()}} >Query Beacons</button>&nbsp;
                    <button onClick={()=>{this.exportBeaconLabelCsv()}} >Export Labels CSV</button>&nbsp;
                    <button onClick={()=>{this.exportWearables()}} >Export Wearable Script</button>
                    <button className="" title="command to connect to factorypi.  The command to start AutomatedBeaconUpdate will be put into clipboard" onClick={() => functions.openWindow( functions.getSSHUrlForBeaconConfig() ) }>Start BeaconConfig<img alt='copy' height="15px" src="icons8-clone-figure-32.png"></img></button>
                </div>
                <TableScrollbar height="80vh">
                    <ErrorBoundary>
                        <Table columns={[
                                    { key: 'major', title:"Major", width :5 }                                  
                                    , { key: 'minor', title:"Minor", width :5 }
                                    , { key: 'barcode', title:"Bar Code", width :5 }
                                    , { key: 'last_updated', title:"Last Updated", width :5  }
                                    , { key: 'device', title:"device", width :5  }
                                    , { key: 'mac_address', title:"MAC", width :10 , render:tableColumnRender.renderSimpleNote}
                                    , { key: 'original_major', title:"Original Major", width :5 , render : tableColumnRender.renderNoteSimple}
                                    , { key: 'original_minor', title:"Original Minor", width :5 , render : tableColumnRender.renderNoteSimple}
                                    , { key: 'firmware_version', title:"Firmware", width :10 , render : tableColumnRender.renderNoteSimple}
                                    , { key: 'countdown_behavior', title:"Behavior", width :5 , render : tableColumnRender.renderNoteSimple}
                                    , { key: 'milli_volts', title:" Milli Volts", width :5, render : tableColumnRender.renderNoteSimple}
                                    //, { key: 'right_device', title:"Right device", width :5 }
                                    //, { key: 'right_mac_address', title:"Right MAC", width :10 }
                                    //, { key: 'right_original_major', title:"Right Original Major", width :5 }
                                    //, { key: 'right_original_minor', title:"Right Original Minor", width :5 }
                                    //, { key: 'right_firmware_version', title:"Right Firmware", width :10 }
                                    //, { key: 'right_countdown_behavior', title:"Right Behavior", width :5 }
                                    //, { key: 'right_milli_volts', title:"Right Milli Volts", width :5}
                                    , { key: 'hostnames', title:"Hostnames", width :25}
                                 
                                ]} 
                                dataSource={this.state.beacons} 
                                onRowClick={this.openHistory.bind(this)}
                                />
                    </ErrorBoundary>
                </TableScrollbar>
                <BeaconHistoryPopup
                    securityObject={this.props.securityObject}
                    beaconPair={this.state.beaconPair}
                    closeBeaconHistoryPopup={this.closeBeaconHistoryPopup.bind(this)}
                    >
                </BeaconHistoryPopup>
            </div>
        );
    }

    // load the table
    queryBeacons(params){
        db.getBeacons( 
            document.getElementById("major").value
            ,document.getElementById("minor").value
            ,document.getElementById("barcode").value
            ,document.getElementById("hostnames").value
            ,this.props.securityObject
            ,(beaconList) => {

                // add extra fields
                beaconList.forEach( wearable =>{
                    wearable.mac_address="l:"+wearable.left_mac_address+"\nr:"+wearable.right_mac_address;
                    wearable.mac_device="l:"+wearable.left_mac_device+"\nr:"+wearable.right_mac_device;
                    wearable.firmware_version="l:"+wearable.left_firmware_version+"\nr:"+wearable.right_firmware_version;
                    wearable.countdown_behavior="l:"+wearable.left_countdown_behavior+"\nr:"+wearable.right_countdown_behavior;
                    wearable.milli_volts="l:"+wearable.left_milli_volts+"\nr:"+wearable.right_milli_volts;
                    wearable.original_major="l:"+wearable.left_original_major+"\nr:"+wearable.right_original_major;
                    wearable.original_minor="l:"+wearable.left_original_minor+"\nr:"+wearable.right_original_minor;
                })
                this.setState({
                    beacons : beaconList
                })
            }
            ,params
        )
    }
    exportBeaconLabelCsv(params){
        let url=this.props.securityObject.httpServer
                +"api/get/beaconForLabels?sessionId="
                +this.props.securityObject.userSessionId;
        if( document.getElementById("major").value!==""){
            url+=`&major=${document.getElementById("major").value}`;
        }
        if( document.getElementById("minor").value!==""){
            url+=`&minor=${document.getElementById("minor").value}`;
        }
        if( document.getElementById("barcode").value!==""){
            url+=`&barcode=${document.getElementById("barcode").value}`;
        }
        if( document.getElementById("hostnames").value!==""){
            url+=`&hostnames=${document.getElementById("hostnames").value}`;
        }        
        url+=`&orderBy=major,minor`;
        window.open(url);
    }
    openHistory( rowData, rowIndex ){
        this.setState({
            beaconPair:rowData
        });
    }
    closeBeaconHistoryPopup(){
        this.setState({
            beaconPair:undefined
        });
    }
    exportWearables(){
        let result='url=localhost\n'
//        result+='namePrefix=\n';
        result+='port=3000\n';
        //let iPos=0;
        //let types={ 'W-L': {'url':'headset' }
        //            ,'G-L': {'url':'toddle' }
        //            ,'T-L': {'url':'toddle' }
        //            };
        let script='echo adding ${wearable.minor};curl -X POST "${url}${types[wearable.left_device].url}" -H '
        +' "accept: application/json" -H  "Content-Type: application/json" '
        +'-d "{  &quot;active&quot;: true,  &quot;name&quot;: &quot;${wearable.minor}&quot;, '
        +' &quot;left&quot;: { &quot;bdaddr&quot;: { &quot;bdaddr&quot;: &quot;${wearable.left_mac_address}&quot;, &quot;type&quot;: &quot;random&quot; }, &quot;major&quot;: ${wearable.major}, &quot;minor&quot;: ${wearable.minor}, &quot;uuid&quot;: &quot;${wearable.left_uuid}&quot;  },'
        +' &quot;right&quot;: {&quot;bdaddr&quot;: { &quot;bdaddr&quot;: &quot;${wearable.right_mac_address}&quot;,&quot;type&quot;: &quot;random&quot; }, &quot;major&quot;: ${wearable.major}, &quot;minor&quot;: ${wearable.minor},&quot;uuid&quot;: &quot;${wearable.right_uuid}&quot;  }, '
        +' &quot;test&quot;: false}"';

        this.state.beacons.forEach( wearable =>{
            //let wearableType=types[iPos];
            //let url="http://$url:$port/api/";
            let line=eval("`"+script+"`");
            line=line.replaceAll('&quot;','\\"')
            result+=line+"\n";
        })
        console.log(result);
        functions.downloadFile(`ExportWearableScript-`
                +'major-'+document.getElementById("major").value
                +'minor-'+document.getElementById("minor").value
                , result, 'txt');
    }


}